export enum UserCategory {
  PARTNER = 'PARTNER',
  MEMBER = 'MEMBER',
}
